import React, {Component} from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';
import {withRouter} from 'react-router';
// import {Link} from 'react-router-dom';
import ReactDOM from 'react-dom';

import Error505Page from '../Error505Page.js';
import LoadingIndicator from '../LoadingIndicator.js';

class CollectionAbout extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isButtonVisible: false,
        };
    };

    componentDidMount() {
        this.domNode = ReactDOM.findDOMNode(this.colBtn);
        this.handleScroll();
        window.addEventListener('scroll', this.handleScroll);
    };

    componentDidUpdate(prevProps) {
        const { data} = this.props;

        if (!this.domNode || (prevProps.data && data && prevProps.data.id !== data.id)) {
            this.domNode = ReactDOM.findDOMNode(this.colBtn);
        }
    };

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    };

    handleScroll = (event) => {
        if (this.domNode) {
            this.colBtnOffset = this.domNode.getBoundingClientRect();
            this.setState({isButtonVisible: this.colBtnOffset.y + this.colBtnOffset.height < 0});
        }
    };

    render() {
        const { clang, data, isLoadingError, isFetching } = this.props;
        const { isButtonVisible } = this.state;

        if (isLoadingError) {
            return <div className="collection-about">
                       <Error505Page />
                   </div>;
        }

        if (isFetching) {
            return <div className="collection-about">
                       <LoadingIndicator />
                   </div>;
        }

        if (!data) {
            return null;
        }

        return (
            <article className="collection-about">
                <h2 className="collection-about--title">{lang[clang].collections.collection}</h2>
                <div className="collection-about__content">
                    <span className="collection-about__content-paperclip"></span>
                    <h2 className="collection-about__title" dangerouslySetInnerHTML={{__html: data.acf.collection_title}}></h2>

                    <a className="collection-about__button-results"
                     href={data.acf.collection_link} ref={el => this.colBtn = el}
                     title={data.acf.collection_link_desc}>
                        {data.acf.collection_link_desc}
                        <span className="collection-about__button-results--img"></span>
                    </a>
                    <div className="collection-about__desc">
                        <div className="collection-about__desc" dangerouslySetInnerHTML={{__html: data.acf.collection_desc}}></div>
                    </div>


                </div>
                {isButtonVisible &&
                    <a className="collection-about__button" href={data.acf.collection_link}>
                        {lang[clang].collections.see_results}
                    </a>}
            </article>
        );
    }
};

CollectionAbout.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default withRouter(connect(mapStateToProps)(CollectionAbout));



// WEBPACK FOOTER //
// ./src/components/collections/CollectionAbout.js